import { PlusOutlined } from '@ant-design/icons'
import { Badge, Button, Collapse, Flex, Space, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import { path } from 'src/libs'
import { STATUS_PERIOD } from 'src/pages/budget/const'
import styles from '../styles.module.css'
import { useBudgetPeriod } from 'src/pages/budget/budgetRequests/hooks'

type Props = {
  budgetPeriodName: string | null
}

export const OwnEmpty = ({ budgetPeriodName }: Props) => {
  const navigate = useNavigate()
  const { budgetPeriod } = useBudgetPeriod()

  const { currentPeriodId, byId } = budgetPeriod

  const currentPeriodStatus = currentPeriodId
    ? byId.get(currentPeriodId)?.status
    : undefined
  const isOutOfBudgetRequest =
    currentPeriodStatus !== STATUS_PERIOD.OPEN_CREATE

  const { Title, Text } = Typography

  return (
    <Collapse
      items={[
        {
          key: '1',
          label: (
            <Space>
              <Text strong style={{ fontSize: 28 }}>
                Мои заявки / {budgetPeriodName ?? ''}
              </Text>
              <Badge
                count={0}
                showZero
                color="white"
                style={{ color: 'black', borderRadius: '4px' }}
              />
            </Space>
          ),
          children: (
            <Flex
              vertical
              justify="center"
              align="center"
              gap="middle"
              style={{ textAlign: 'center', height: 200 }}
            >
              <Title level={3} style={{ marginBottom: 0 }}>
                У вас нет заявок
              </Title>
              <Text style={{ fontSize: 16 }}>
                Здесь будут собраны все ваши заявки на бюджет, которые ожидают согласования.
              </Text>
              {currentPeriodStatus !== STATUS_PERIOD.CLOSED && (
                <Button
                  size="large"
                  color="geekblue"
                  variant={isOutOfBudgetRequest ? 'outlined' : 'solid'}
                  icon={<PlusOutlined />}
                  iconPosition="start"
                  key="btn_add_budget_request"
                  onClick={() =>
                    navigate(path.budget.budgets.create(currentPeriodId))
                  }
                >
                  {isOutOfBudgetRequest
                    ? 'Заявка вне бюджета'
                    : 'Новая заявка'}
                </Button>
              )}
            </Flex>
          ),
        },
      ]}
      defaultActiveKey="1"
      className={styles.collapse}
      expandIconPosition="end"
      style={{ backgroundColor: 'var(--color-blue-20)' }}
    />
  )
}
